import styled from 'styled-components'

const modalWidth = 840
enum Breakpoint {
  Mobile = 768,
  Tablet = 1024,
  Desktop = 1280,
  Wide = 1440,
  SuperWide = 1680,
  UltraWide = 1920,
}

export const BackgroundOverlay = styled.div`
  background: var(--black-2, #1e1e21);
  bottom: 0;
  left: 0;
  opacity: 0.5;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 998;
`

export const CloseButton = styled.div`
  align-items: center;
  background: var(--Grey-Gandalf, #ededed);
  border-radius: 80px;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: center;
  position: absolute;
  right: 12px;
  top: 12px;
  width: 36px;
`

export const ModalContent = styled.div`
  align-items: flex-start;
  background: var(--white-2, white);
  border-radius: 20px;
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
  left: calc(50% - ${modalWidth / 2}px);
  max-height: 95vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 26px 36px 36px;
  position: fixed;
  top: 30%;
  width: ${modalWidth}px;
  z-index: 999;

  @media (max-width: ${Breakpoint.Tablet}px) {
    left: 24px;
    right: 24px;
    top: 24px;
    width: auto;
  }
`

export const OtherReportsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
`

export const Section = styled.div`
  align-items: start;
  background: var(--grey-6, #f1f1f1);
  border-radius: 20px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`

export const SectionColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${Breakpoint.Tablet}px) {
    flex-direction: row;
  }

  @media (max-width: ${Breakpoint.Mobile}px) {
    flex-direction: column;
  }
`

export const SectionColumns = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: ${Breakpoint.Tablet}px) {
    flex-direction: column;
    flex: 1;
  }
`

export const SectionIcon = styled.div`
  display: flex;
`

export const SectionTitle = styled.div`
  align-items: center;
  color: var(--black-2, #1e1e21);
  display: flex;
  flex-direction: row;
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  gap: 12px;
  line-height: 24px;
  margin-bottom: 4px;
`

export const ReportLink = styled.a`
  color: var(--black-2, #1e1e21);
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const TextIntro = styled.div`
  color: var(--black-2, #1e1e21);
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 8px;
`

export const Title = styled.div`
  color: var(--black-2, #1e1e21);
  font-family: Lato;
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 46px;
`
export const Label = styled.div`
  color: #5b5f67;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px; /* 120% */
  margin-bottom: 6px;
  margin-top: 24px;
  text-transform: uppercase;
`

export const LinksContainer = styled.div`
  margin-top: 6px;
`

export const MenuItem = styled.div<{
  hasSubMenu: boolean
  isSelected: boolean
}>`
  > a {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 8px 10px;
    cursor: pointer;
    transition: background-color 0.2s ease, border-radius 0.2s ease;

    ${({ hasSubMenu }) =>
      hasSubMenu &&
      `
      padding: 8px 10px;
      margin-bottom: 0;
  `};

    text-decoration: none;
    color: white;
    font-weight: ${({ isSelected }) => (isSelected ? 900 : 700)};
    border-radius: 12px;

    ${({ isSelected }) =>
      isSelected &&
      `
      background: #1e1e21;
    `};

    &:hover {
      background: #1e1e21;
      animation: 0.2s ease;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/Navigation/ConciergeReports.style.tsx